import axios from 'axios';
import { getConfig } from '../config';

export const MSAL_SCOPES = ["api://campusevolve/access_as_user"];

export const FEEDBACK_QUESTIONS = [
  {
    param: 'advisor',
    type: 'checkbox',
    label: 'I’m an advisor',
    values: ['No', 'Yes']
  },
  {
    param: 'overall',
    type: 'multiradio',
    label: 'How would you rate the AI Guide overall?',
    values: ['Awful', 'Just OK', 'Pretty Good', 'Fantastic!'],
    prompts: [
      {
        param: 'think',
        label: 'I think it is'
      }
    ]
  },
  /*
  {
    param: 'help',
    type: 'multiradio',
    label: 'Did the AI Guide help you...',
    values: ['No', 'A little bit', 'Yes!'],
    prompts: [
      {
        param: 'explore',
        label: 'Explore where you want to go on your path?'
      },
      {
        param: 'choose',
        label: 'Choose goals for your path?'
      },
      {
        param: 'understand',
        label: 'Understand what to do next on your path?'
      }
    ]
  },
  {
    param: 'liked',
    type: 'textarea',
    label: 'What did you like most?',
    placeholder: 'Enter your answer',
  },
  {
    param: 'disliked',
    type: 'textarea',
    label: 'What did you like least?',
    placeholder: 'Enter your answer'
  },
  {
    param: 'ideas',
    type: 'textarea',
    label: 'Give us an idea to make it better!',
    placeholder: 'Enter your answer'
  }*/
  {
    param: 'rightwrong',
    type: 'textarea',
    label: 'What went right or wrong?',
    placeholder: 'Enter your answer'
  },
  {
    param: 'use',
    type: 'textarea',
    label: 'What would get you to use this outside of class?',
    placeholder: 'Enter your answer'
  }
];

export const INITIAL_PROFILE = [
  { param: 'name', category: 'basic', type: 'text', label: 'Name' },
  { param: 'direction', category: 'other', type: 'text', label: 'Direction After High School' },
  { param: 'future', category: 'other', type: 'text', label: 'What You’re Thinking About' },
  { param: 'values', category: 'other', type: 'text', label: 'What Matters Most to Me' },
  { param: 'strengths', category: 'other', type: 'text', label: 'What Comes Naturally to Me' },
  { param: 'geography', category: 'other', type: 'text', label: 'How Far from Home' },
  { param: 'financial', category: 'other', type: 'text', label: 'Financial Aid' }
];

export const ONBOARDING_SLIDES = [
  {
    id: 'welcome',
    type: 'guide',
    bubbles: [
      'Hey — I’m your AI Guide. I’m here to help you figure out what’s next after high school. No right answers. Let’s start.'
    ],
    action: 'Start',
    next: 'disclosure'
  },
  {
    id: 'disclosure',
    type: 'guide',
    bubbles: [
      'I’m an AI — not a real person or a school counselor.',
      'I can make mistakes. For anything important, check with your advisor or a trusted adult.',
      'If you tell me something that suggests you might not be safe, adults at your school may be notified so they can help you.'
    ],
    action: 'Got it — let’s go',
    sendAction: 'disclosure',
    prev: 'welcome',
    next: 'name'
  },
  {
    id: 'name',
    type: 'guide',
    param: 'name',
    category: 'basic',
    input: 'text',
    placeholder: 'Choose your name',
    showPrivacy: true,
    bubbles: [
      'This guide helps you explore life after high school — jobs, education, training, and more. Your story starts with who you are and what matters to you.',
      'What would you like to be called?'
    ],
    action: 'Next',
    canSkip: true,
    prev: 'disclosure',
    next: 'direction'
  },
  {
    id: 'direction',
    type: 'guide',
    param: 'direction',
    category: 'other',
    input: 'multiselect',
    placeholder: 'Something else?',
    bubbles: [
      'What are you planning to do after high school? You can choose more than one.'
    ],
    values: [
      { label: 'Work right away', sublabel: 'Find work after graduation. No extra schooling required.' },
      { label: 'Education', sublabel: 'College, university, or other school after high school.' },
      { label: 'Apprenticeship', sublabel: 'Learn a trade while you earn. Programs usually take 1–5 years.' },
      { label: 'Job Training', sublabel: 'Short programs that qualify you for a specific job — often weeks or months.' },
      { label: 'Military', sublabel: 'Serve in the Army, Navy, Air Force, Marines, Coast Guard, or Space Force.' },
      { label: 'I don’t know', sublabel: 'That’s okay — we’ll figure it out together.' }
    ],
    action: 'Next',
    prev: 'name',
    next: 'future'
  },
  {
    id: 'future',
    type: 'guide',
    param: 'future',
    category: 'other',
    input: 'textarea',
    placeholder: 'For example: I want to go to community college for nursing. Or: I like building things but don’t know what to study. Or: I have no idea yet — that’s okay too.',
    bubbles: [
      'What are you thinking about for your future — school, a career, or both? Even a rough idea is fine.'
    ],
    action: 'Next',
    canSkip: true,
    prev: 'direction',
    next: 'values'
  },
  {
    id: 'values',
    type: 'guide',
    param: 'values',
    category: 'other',
    input: 'select',
    bubbles: [
      'What matters most to you? Pick one.'
    ],
    values: [
      { label: 'Economic stability', sublabel: 'Having enough money to feel secure and take care of what matters.' },
      { label: 'Helping people', sublabel: 'Doing work that makes a real difference for others or my community.' },
      { label: 'Following my passion', sublabel: 'Building a life around what I love, even if the path isn’t clear yet.' }
    ],
    action: 'Next',
    canSkip: true,
    prev: 'future',
    next: 'strengths'
  },
  {
    id: 'strengths',
    type: 'guide',
    param: 'strengths',
    category: 'other',
    input: 'multiselect',
    placeholder: 'Something else?',
    bubbles: [
      'What are you good at or proud of? Pick as many as you want.'
    ],
    values: [
      { label: 'Supporting my family' },
      { label: 'Working hard — not giving up' },
      { label: 'Being a good friend' },
      { label: 'Speaking more than one language' },
      { label: 'Working with my hands' },
      { label: 'Figuring things out on my own' },
      { label: 'Standing up for what’s right' },
      { label: 'Being proud of where I’m from' },
      { label: 'Sports or being active' },
      { label: 'Cooking or making things' },
      { label: 'Taking care of people' },
      { label: 'Making art, music, or dance' },
      { label: 'Gaming or creating online' }
    ],
    action: 'Next',
    canSkip: true,
    prev: 'values',
    next: 'geography'
  },
  {
    id: 'geography',
    type: 'guide',
    param: 'geography',
    category: 'other',
    input: 'select',
    placeholder: 'Somewhere else in mind? Type it here.',
    bubbles: [
      'How close to home are you thinking about staying?'
    ],
    values: [
      { label: 'Stay close to home' },
      { label: 'Within an hour or two' },
      { label: 'Stay in Washington' },
      { label: 'Open to anywhere' },
      { label: 'I don’t know' }
    ],
    action: 'Next',
    canSkip: true,
    prev: 'strengths',
    next: 'financial'
  },
  {
    id: 'financial',
    type: 'guide',
    param: 'financial',
    category: 'other',
    input: 'select',
    bubbles: [
      'Paying for education or training after high school is a big deal. Where are you in figuring out financial aid?'
    ],
    values: [
      { label: 'I haven’t started looking for financial aid yet' },
      { label: 'I have looked but haven’t applied yet' },
      { label: 'I have applied but haven’t figured it all out' },
      { label: 'I have financial aid all set up' }
    ],
    action: 'Next',
    canSkip: true,
    prev: 'geography',
    next: 'path'
  }
];

export const TIPS = [
  'No plan yet? That’s more common than you think. There’s time — and the AI Guide can help you start sorting it out.',
  'Working on your High School and Beyond Plan? Chat with the AI Guide about careers and pathways — it can help you figure out what to put down.',
  'Apprenticeships pay you while you train. Electricians, plumbers, and HVAC techs in Washington start around $20/hour and go up from there.',
  'Some jobs pay well without a degree. The AI Guide can show you what’s hiring in your area and what it actually pays.',
  'Haven’t filed for financial aid yet? FAFSA and WAFSA are both open. WAFSA is for students who can’t file FAFSA — same money, different form. Both cover community college and some trade programs, not just four-year schools.',
  'Got a financial aid letter that’s hard to understand? Bring it to your CSF advisor or school counselor. They read these every day.',
  'A two-year college costs much less than a four-year. Same first two years of credit, less debt.',
  'If you took Running Start courses, those credits are yours — they transfer to most Washington colleges.',
  'Worried about your future path? Your CSF advisor is there for exactly this. Reach out — no judgment.'
];
export const TIPS_INTERVAL = 8000;

export const PROFILE_CATEGORIES = [
  { name: 'basic', label: 'Your Basic Information' },
  { name: 'other', label: 'Here\'s what I know about you now' }
];
export const PROFILE_MIN_PARAMS = 4;
export const PROFILE_PARAMS = [
  {
    category: 'basic',
    name: 'personalEmail',
    label: 'Personal Email',
    notes: 'Keep access after graduation. (Must be 18.)',
    placeholder: 'e.g. name@gmail.com',
    validations: [
      { regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, error: 'Enter a valid email address' }
    ],
    successMessage: 'Got it! We’ll send you a reminder this summer to log back in.'
  },
  {
    category: 'basic',
    name: 'personalPhone',
    label: 'Phone Number',
    notes: 'Keep access after graduation. (Must be 18.)',
    placeholder: 'e.g. 4255552424',
    validations: [
      { regex: /^\d{10}$/, error: 'Enter a valid phone number' }
    ],
    successMessage: 'Got it! We’ll send you a reminder this summer to log back in.'
  }
];
export const PROFILE_POLLING_ATTEMPTS = 3;
export const PROFILE_POLLING_INTERVAL = 2000;
export const PROFILE_PROMPT = 'hello';

const config = getConfig();

axios.interceptors.request.use(
  async (request) => {
    const token = getLocal('token');

    if (token) {
      request.headers.authorization = `Bearer ${token}`;
    }

    return request;
  }, (e) => {
    return Promise.reject(e);
  }
);

export const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

//Local Storage
export const deleteLocal = (key) => {
  localStorage.removeItem(key);
};

export const emptyLocal = () => {
  localStorage.clear();
};

export const getLocal = (key) => {
  const v = localStorage.getItem(key);
  return v ? JSON.parse(v) : false;
};

export const setLocal = (key, val) => {
  localStorage.setItem(key, val ? JSON.stringify(val) : false);
};

export const getActions = async (category) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/api/actions?category=${category}`);

    if (response?.data?.length) {
      return response.data;
    }

    return [];
  } catch (e) {
    throw new Error('An error occurred while getting actions');
  }
};

export const sendAction = async (category, messageId = null, metaData = null) => {
  try {
    const data = {
      category
    };

    if (messageId) {
      data.messageIds = [messageId];
    }

    if (metaData) {
      data.meta_data = metaData;
    }

    const response = await axios.post(`${process.env.REACT_APP_API}/api/actions`, data);

    if (response?.data?._id) {
      return response.data;
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while sending action');
  }
};

export const getActivity = async (id) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/api/activity/${id}`);

    if (response?.data?.activity?._id) {
      return response.data;
    }

    return [];
  } catch (e) {
    throw new Error('An error occurred while getting activity');
  }
};

export const updateActivity = async (id, status) => {
  try {
    let data = {
      status
    };

    const response = await axios.patch(`${process.env.REACT_APP_API}/api/activity/${id}`, data);

    if (response?.data?._id) {
      return response.data;
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while updating activity');
  }
};

export const updateTask = async (id, status) => {
  try {
    let data = {
      status
    };

    const response = await axios.patch(`${process.env.REACT_APP_API}/api/tasks/${id}`, data);

    if (response?.data?._id) {
      return response.data;
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while updating task');
  }
};

export const getChat = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/api/messages?category=question`);

    if (response?.data?.length) {
      return response.data;
    }

    return [];
  } catch (e) {
    throw new Error('An error occurred while getting chat');
  }
};

export const getPath = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/api/path`);

    if (response?.data?._id && response.data.activities?.length) {
      return response.data.activities.sort((a, b) => a.order - b.order);
    }

    return [];
  } catch (e) {
    throw new Error('An error occurred while getting path');
  }
};

export const getPathExists = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/api/path/exists`);

    if (response?.data) {
      return response.data.exists;
    }

    return false;
  } catch (e) {
    throw new Error('An error occurred while getting path');
  }
};

export const getPlan = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/api/plan`);

    if (response.data.plans?.length) {
      return response.data.plans.filter(item => item.category !== 'start');
    }

    return [];
  } catch (e) {
    throw new Error('An error occurred while getting plan');
  }
};

export const getTenant = async (slug) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/api/tenants/public/${slug}`);

    if (response.data?.slug) {
      return response.data;
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while getting tenant');
  }
};

export const getProfileChat = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/api/profile/chat`);

    if (response?.data?.length) {
      return response.data;
    }

    return [];
  } catch (e) {
    throw new Error('An error occurred while getting chat');
  }
};

export const sendActivityMessage = async (id, message, parentMessageId = null) => {
  try {
    let data = {
      message
    };

    if (parentMessageId) {
      data.parentMessageId = parentMessageId;
    }

    const response = await axios.post(`${process.env.REACT_APP_API}/api/activity/${id}`, data);

    if (response?.data?.latestMessage?._id) {
      return {
        message: response.data.latestMessage,
        profile: null,
        tasks: response.data.latestMessage.tasks?.length ? response.data.latestMessage.tasks : []
      };
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while sending chat');
  }
};

export const sendActivityMessageStreaming = async (id, message, parentMessageId = null) => {
  try {
    let data = {
      message
    };

    if (parentMessageId) {
      data.parentMessageId = parentMessageId;
    }

    const response = await fetch(`${process.env.REACT_APP_API}/api/activity/${id}/stream`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${getLocal('token')}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (response?.body) {
      return response.body;
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while sending chat');
  }
};

export const sendChatMessage = async (message, parentMessageId = null) => {
  try {
    let data = {
      category: 'question',
      message
    };

    if (parentMessageId) {
      data.parentMessageId = parentMessageId;
    }

    const response = await axios.post(`${process.env.REACT_APP_API}/api/messages`, data);

    if (response?.data?.messages?.length) {
      return {
        message: response.data.messages[0],
        profile: response.data.profile
      };
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while sending chat');
  }
};

export const sendChatMessageStreaming = async (message, parentMessageId = null) => {
  try {
    let data = {
      category: 'question',
      message
    };

    if (parentMessageId) {
      data.parentMessageId = parentMessageId;
    }

    const response = await fetch(`${process.env.REACT_APP_API}/api/messages/stream`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${getLocal('token')}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (response?.body) {
      return response.body;
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while sending chat');
  }
};

export const sendProfileMessage = async (message, parentMessageId = null) => {
  try {
    let data = {
      message
    };

    if (parentMessageId) {
      data.parentMessageId = parentMessageId;
    }

    const response = await axios.post(`${process.env.REACT_APP_API}/api/profile/chat`, data);

    if (response?.data?.message?._id) {
      return {
        message: response.data.message,
        profile: response.data.profile
      };
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while sending chat');
  }
};

export const sendProfileMessageStreaming = async (message, parentMessageId = null) => {
  try {
    let data = {
      message
    };

    if (parentMessageId) {
      data.parentMessageId = parentMessageId;
    }

    const response = await fetch(`${process.env.REACT_APP_API}/api/profile/chat/stream`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${getLocal('token')}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (response?.body) {
      return response.body;
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while sending chat');
  }
};

export const postSlackMessage = async (message) => {
  try {
    const data = {
      message
    };

    await axios.post(`${process.env.REACT_APP_API}/api/external/slack`, data);

    return true;
  } catch (e) {
    throw new Error('An error occurred while sending feedback');
  }
};

export const forgetUser = async () => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API}/api/unlink-me`, null);

    if (response?.data) {
      return response.data;
    }

    return null;
  } catch (error) {
    throw new Error('An error occurred while forgetting user');
  }
};

export const resetProfile = async () => {
  try {
    emptyLocal();
    window.location = '/';

    return null;
  } catch (e) {
    throw new Error('An error occurred while resetting profile');
  }
};

export const startOver = async () => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API}/api/reset-me`, null);

    if (response?.data?.status) {
      await sendAction('signup');

      window.location = '/';
    }

    return null;
  } catch (error) {
    throw new Error('An error occurred while resetting user');
  }
};

export const syncProfile = async (email = null, phone = null) => {
  try {
    let data = {};

    if (email || phone) {
      const tenant = getLocal('tenant');

      data = {
        email,
        phone,
        meta_data: INITIAL_PROFILE.map(item => {
          if (item.param === 'location' && !item.value) {

            if (tenant?.location) {
              item.value = tenant.location;
            }
          }

          return item;
        })
      };

      if (tenant) {
        if (tenant.slug) {
          data.slug = tenant.slug;
        }
      }
    }

    const response = await axios.post(`${process.env.REACT_APP_API}/api/profile`, data);

    if (response?.data?._id) {
      setLocal('profile', response.data);

      return response;
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while creating profile');
  }
};

export const updateProfileAsTester = async (isTester) => {
  try {
    const data = {
      isTester
    };

    const response = await axios.patch(`${process.env.REACT_APP_API}/api/profile`, data);

    if (response?.data?._id) {
      const newProfile = response.data;

      setLocal('profile', newProfile);

      return newProfile;
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while updating profile');
  }
};

export const updateProfile = async (param, value) => {
  try {
    let profile = getLocal('profile');

    if (profile?._id) {
      let paramFound = false;

      if (!profile?.meta_data?.length) {
        profile.meta_data = [];
      }

      if (PROFILE_PARAMS.find(item => item.name === param)) {
        profile[param] = value;

        paramFound = true;
      } else {
        let paramIndex = profile.meta_data.findIndex(p => p.param === param);

        if (paramIndex >= 0) {
          profile.meta_data[paramIndex].value = value;

          paramFound = true;
        } else {
          paramIndex = INITIAL_PROFILE.findIndex(p => p.param === param);

          if (paramIndex >= 0) {
            profile.meta_data.push({
              ...INITIAL_PROFILE[paramIndex],
              value: value
            });

            paramFound = true;
          }
        }
      }

      if (paramFound) {
        const data = {
          email: profile.email,
          phone: profile.phone,
          personalEmail: profile.personalEmail,
          personalPhone: profile.personalPhone,
          meta_data: profile.meta_data
        };
  
        const response = await axios.patch(`${process.env.REACT_APP_API}/api/profile`, data);
  
        if (response?.data?._id) {
          const newProfile = response.data;
  
          setLocal('profile', newProfile);
  
          return newProfile;
        }
      }
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while updating profile');
  }
};

export const sendOTP = async (phone) => {
  try {
    const data = {
      client_id: config.clientId,
      connection: 'sms',
      phone_number: phone,
      send: 'code'
    };

    const response = await axios.post(`https://${config.domain}/passwordless/start`, data);

    if (response?.status === 200) {
      return response.data;
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while sending OTP');
  }
};